



































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import MainLeft from "../../../sjzx/modules/zbsjk/components//nav-left.vue";
import Shetuzidian from "./shetuzidian.vue";
import Maituzidian from "./maituzidian.vue";
@Component({
  components: {
    MainHeader,
    MainLeft,
    Shetuzidian,
    Maituzidian,
  },
})
export default class Dictionary extends Vue {
  private currentPart = "定性特征参数";
  private data: any = {};
  private cState: any = "舌图字典";
  private get user() {
    return this.$store.state.user;
  }
  private changeState(state) {
    this.cState = state;
  }
}
